import { memo, Fragment } from 'react';
import styles from './VisuallyHiddenRows.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const VisuallyHiddenRows = /*#__PURE__*/memo(function Rows({
  data,
  formatYAxisLabel,
  xAxisLabels
}) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("g", {
      role: "row",
      children: [/*#__PURE__*/jsx("text", {
        role: "rowheader"
      }), xAxisLabels.map((xAxisLabel, index) => {
        return /*#__PURE__*/jsx("text", {
          className: styles.VisuallyHidden,
          role: "columnheader",
          children: xAxisLabel
        }, `a11y-${xAxisLabel}-${index}`);
      })]
    }), data.map(({
      name,
      data
    }, index) => {
      return /*#__PURE__*/jsxs("g", {
        role: "row",
        children: [/*#__PURE__*/jsx("text", {
          role: "rowheader",
          className: styles.VisuallyHidden,
          children: name
        }), data.map(({
          value,
          key
        }, index) => {
          return /*#__PURE__*/jsx("text", {
            role: "cell",
            className: styles.VisuallyHidden,
            children: value == null ? '' : formatYAxisLabel(value)
          }, `cell-${name}-${value}-${key}-${index}`);
        })]
      }, `row-${name}-${index}`);
    })]
  });
});

export { VisuallyHiddenRows };
